module.exports = __webpack_public_path__ + "media/components/src/assets/images/blogs/10-cd21262ad9ac8a14fffd8413a5c8ff34.jpg";